"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpolatePrompt = void 0;
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
/**
 * The purpose of this method is to interpolate loanTapeMetadata variables into
 * an ai2Csv prompt (template), and additionally support hyperformula evaluation of those variables.
 *
 * The method first substitutes loanTapeMetadata variables, and then evaluates the {{ =hyperformulas }}
 *
 * Input: reportingDate: '2025-01-25'
 * 'Can you extract the {{ =ROUNDUP(MONTH(DATEVALUE("loanTapeMetadata.reportingDate"))/3, 0) }}Q {{ =YEAR(DATEVALUE("loanTapeMetadata.reportingDate")) }} income statement?'
 *
 * Output:
 * 'Can you extract the 1Q 2025 income statement?'
 */
const interpolatePrompt = ({ prompt, loanTapeMetadata, }) => {
    let interpolatedPrompt = prompt;
    // replace loanTapeMetadata variables with values
    Object.entries(loanTapeMetadata).forEach(([prop, value]) => {
        const safeValue = value === undefined || value === null ? '' : String(value);
        const regex = (0, calc_agent_1.generateLoanTapeMetadataRegex)(prop);
        interpolatedPrompt = interpolatedPrompt.replace(regex, safeValue);
    });
    const regex = /{{\s*(=.+?)\s*}}/g;
    const errors = [];
    // Replace each {{ =... }} with the evaluated result
    interpolatedPrompt = interpolatedPrompt.replace(regex, (_full, innerWithEquals) => {
        try {
            // Strip leading '=' used for Excel-like formulas
            const expression = innerWithEquals.startsWith('=')
                ? innerWithEquals.slice(1)
                : innerWithEquals;
            const engine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [expression], undefined);
            const value = engine.evaluate(expression);
            return String(value);
        }
        catch (err) {
            errors.push((0, common_1.getErrorMessage)(err));
            return 'Unable to evaluate expression.';
        }
    });
    if (errors.length) {
        return { success: false, errors };
    }
    return { success: true, prompt: interpolatedPrompt };
};
exports.interpolatePrompt = interpolatePrompt;
//# sourceMappingURL=interpolatePrompt.js.map